import * as React from "react"

const NoUnitsAsset = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={194.313}
    height={211.551}
    {...props}
  >
    <defs>
      <clipPath id="a">
        <path
          fill="none"
          d="M0 0h194.313v170.842H0z"
          data-name="Rectangle 58014"
        />
      </clipPath>
    </defs>
    <g data-name="Group 115504">
      <path
        fill="#091b29"
        d="M52.929 200.142v11.28h-1.552l-6.048-7.872v7.872h-1.92v-11.28h1.536l6.048 7.856v-7.856Zm5.824 11.408a4.3 4.3 0 0 1-2.1-.5 3.432 3.432 0 0 1-1.4-1.424 4.515 4.515 0 0 1-.5-2.16 4.468 4.468 0 0 1 .5-2.152 3.444 3.444 0 0 1 1.4-1.416 4.3 4.3 0 0 1 2.1-.5 4.3 4.3 0 0 1 2.1.5 3.394 3.394 0 0 1 1.396 1.424 4.527 4.527 0 0 1 .488 2.152 4.575 4.575 0 0 1-.488 2.16 3.382 3.382 0 0 1-1.392 1.42 4.3 4.3 0 0 1-2.104.496Zm-.016-1.552a1.793 1.793 0 0 0 1.488-.64 2.973 2.973 0 0 0 .512-1.888 2.979 2.979 0 0 0-.512-1.88 1.765 1.765 0 0 0-1.472-.648 1.788 1.788 0 0 0-1.48.648 2.946 2.946 0 0 0-.52 1.88 2.973 2.973 0 0 0 .512 1.888 1.775 1.775 0 0 0 1.472.64Zm10.156-9.856h4.16a5.92 5.92 0 0 1 4.3 1.48 5.512 5.512 0 0 1 1.528 4.152 5.539 5.539 0 0 1-1.528 4.16 5.9 5.9 0 0 1-4.296 1.488h-4.164Zm4.032 9.6q3.888 0 3.888-3.968 0-3.952-3.888-3.952h-1.964v7.92Zm11.22-6.336a3.332 3.332 0 0 1 2.448.8 3.357 3.357 0 0 1 .8 2.464v4.752h-1.9v-1.2a2.088 2.088 0 0 1-.856.976 2.568 2.568 0 0 1-1.352.352 3.139 3.139 0 0 1-1.424-.32 2.533 2.533 0 0 1-1.008-.88 2.224 2.224 0 0 1-.368-1.248 1.977 1.977 0 0 1 .44-1.36 2.644 2.644 0 0 1 1.428-.72 13.041 13.041 0 0 1 2.74-.224h.4v-.368a1.608 1.608 0 0 0-.344-1.152 1.554 1.554 0 0 0-1.148-.356 4.3 4.3 0 0 0-1.3.216 6.6 6.6 0 0 0-1.336.6l-.56-1.376a6.213 6.213 0 0 1 1.584-.688 6.262 6.262 0 0 1 1.756-.268Zm-.464 6.7a1.709 1.709 0 0 0 1.3-.536 1.939 1.939 0 0 0 .5-1.384v-.336h-.288a11.038 11.038 0 0 0-1.664.1 1.616 1.616 0 0 0-.848.336.856.856 0 0 0-.256.656 1.1 1.1 0 0 0 .352.84 1.262 1.262 0 0 0 .904.328Zm9.744-.064a5.939 5.939 0 0 0 .736-.048l-.1 1.488q-.48.048-.88.048a3.383 3.383 0 0 1-2.432-.76 3.016 3.016 0 0 1-.784-2.264v-3.404h-1.5v-1.5h1.5v-2.34h2v2.336h2.068v1.5h-2.064v3.376q0 1.572 1.456 1.572Zm5.268-6.636a3.332 3.332 0 0 1 2.448.8 3.357 3.357 0 0 1 .8 2.464v4.752h-1.9v-1.2a2.088 2.088 0 0 1-.856.976 2.568 2.568 0 0 1-1.352.352 3.139 3.139 0 0 1-1.424-.32 2.533 2.533 0 0 1-1.008-.88 2.224 2.224 0 0 1-.368-1.248 1.977 1.977 0 0 1 .44-1.36 2.644 2.644 0 0 1 1.42-.72 13.041 13.041 0 0 1 2.736-.224h.4v-.368a1.608 1.608 0 0 0-.336-1.152 1.554 1.554 0 0 0-1.148-.356 4.3 4.3 0 0 0-1.3.216 6.6 6.6 0 0 0-1.336.6l-.56-1.376a6.213 6.213 0 0 1 1.584-.688 6.262 6.262 0 0 1 1.76-.268Zm-.464 6.7a1.709 1.709 0 0 0 1.3-.536 1.939 1.939 0 0 0 .5-1.384v-.336h-.288a11.038 11.038 0 0 0-1.664.1 1.616 1.616 0 0 0-.848.336.856.856 0 0 0-.256.656 1.1 1.1 0 0 0 .352.84 1.262 1.262 0 0 0 .9.328Zm12.62-6.508h2.064v1.5h-2.064v6.324h-2v-6.32h-1.5v-1.5h1.5a3.374 3.374 0 0 1 .872-2.528 4.087 4.087 0 0 1 2.712-.952l.784-.048.128 1.488-.752.032a2.1 2.1 0 0 0-1.344.424 1.593 1.593 0 0 0-.4 1.208Zm6.672 7.952a4.3 4.3 0 0 1-2.1-.5 3.432 3.432 0 0 1-1.4-1.424 4.515 4.515 0 0 1-.5-2.16 4.468 4.468 0 0 1 .5-2.152 3.444 3.444 0 0 1 1.4-1.416 4.3 4.3 0 0 1 2.1-.5 4.3 4.3 0 0 1 2.1.5 3.394 3.394 0 0 1 1.396 1.424 4.528 4.528 0 0 1 .488 2.152 4.575 4.575 0 0 1-.488 2.16 3.382 3.382 0 0 1-1.392 1.42 4.3 4.3 0 0 1-2.104.496Zm-.016-1.552a1.793 1.793 0 0 0 1.488-.64 2.973 2.973 0 0 0 .512-1.888 2.979 2.979 0 0 0-.512-1.88 1.765 1.765 0 0 0-1.472-.648 1.788 1.788 0 0 0-1.48.648 2.946 2.946 0 0 0-.52 1.88 2.973 2.973 0 0 0 .512 1.888 1.775 1.775 0 0 0 1.472.64Zm12.832-6.4v7.824h-1.952v-1.2a2.549 2.549 0 0 1-.992.984 2.867 2.867 0 0 1-1.408.344q-2.88 0-2.88-3.232v-4.72h2v4.736a1.888 1.888 0 0 0 .336 1.232 1.3 1.3 0 0 0 1.056.4 1.722 1.722 0 0 0 1.336-.552 2.087 2.087 0 0 0 .5-1.464v-4.352Zm6.624-.192a2.615 2.615 0 0 1 2.1.8 3.628 3.628 0 0 1 .684 2.416v4.8h-2v-4.688a2.074 2.074 0 0 0-.344-1.328 1.322 1.322 0 0 0-1.08-.416 1.826 1.826 0 0 0-1.384.544 2.019 2.019 0 0 0-.52 1.456v4.432h-2v-7.824h1.952v1.168a2.706 2.706 0 0 1 1.072-1.008 3.226 3.226 0 0 1 1.52-.352Zm12.368-3.264v11.28h-1.984v-1.264a2.5 2.5 0 0 1-1.016 1.024 3.066 3.066 0 0 1-1.512.368 3.243 3.243 0 0 1-1.8-.512 3.4 3.4 0 0 1-1.232-1.448 5 5 0 0 1-.44-2.152 4.845 4.845 0 0 1 .44-2.128 3.333 3.333 0 0 1 1.224-1.408 3.309 3.309 0 0 1 1.808-.5 3.131 3.131 0 0 1 1.5.352 2.442 2.442 0 0 1 1.008.992v-4.604Zm-3.984 9.856a1.779 1.779 0 0 0 1.48-.656 2.952 2.952 0 0 0 .52-1.872 2.917 2.917 0 0 0-.52-1.864 1.77 1.77 0 0 0-1.464-.648 1.821 1.821 0 0 0-1.488.64 2.823 2.823 0 0 0-.528 1.84 2.989 2.989 0 0 0 .528 1.884 1.766 1.766 0 0 0 1.472.676Z"
        data-name="Path 100948"
      />
      <g data-name="Group 115501">
        <g clipPath="url(#a)" data-name="Group 115500">
          <path
            fill="#fff"
            d="M4.526 71.929A15.454 15.454 0 0 0 24.04 73.85l-11 11a15.454 15.454 0 0 0 19.514 23.777l-5.774 5.776a15.454 15.454 0 0 0 19.514 23.777l-1.41 1.411a15.455 15.455 0 1 0 21.856 21.856l14.644-14.644a15.454 15.454 0 0 0 23.777 19.514l22.252-22.251a15.454 15.454 0 0 0 23.777 19.514l34.641-34.641a15.454 15.454 0 0 0-19.514-23.777l7.251-7.251a15.454 15.454 0 0 0-19.514-23.777L168.7 59.486a15.454 15.454 0 0 0-19.514-23.777l9.326-9.326a15.455 15.455 0 0 0-21.856-21.857l-20.774 20.777A15.454 15.454 0 0 0 92.1 5.786l-29.16 29.16a15.454 15.454 0 0 0-23.772-19.515L4.526 50.073a15.454 15.454 0 0 0 0 21.856"
            data-name="Path 100878"
          />
          <path
            fill="#fff"
            d="m189.903 137.801-1.069 1.069a1.07 1.07 0 0 0 1.513 1.513l1.069-1.069 1.069 1.069a1.07 1.07 0 0 0 1.514-1.513l-1.069-1.069 1.069-1.069a1.07 1.07 0 0 0-1.514-1.513l-1.069 1.069-1.069-1.069a1.07 1.07 0 0 0-1.513 1.513Z"
            data-name="Path 100879"
          />
          <path
            fill="#fff"
            d="m37.103 160.84-1.069 1.069a1.07 1.07 0 0 0 1.514 1.513l1.069-1.069 1.069 1.069a1.07 1.07 0 0 0 1.513-1.513l-1.069-1.069 1.069-1.069a1.07 1.07 0 1 0-1.513-1.513l-1.066 1.068-1.069-1.069a1.07 1.07 0 1 0-1.514 1.513Z"
            data-name="Path 100880"
          />
          <path
            fill="#fff"
            d="m9.743 66.054-1.069 1.069a1.07 1.07 0 1 0 1.514 1.514l1.069-1.069 1.069 1.069a1.07 1.07 0 0 0 1.514-1.514l-1.069-1.069 1.069-1.069a1.07 1.07 0 1 0-1.514-1.513l-1.069 1.069-1.069-1.069a1.07 1.07 0 1 0-1.514 1.513Z"
            data-name="Path 100881"
          />
          <path
            fill="#fff"
            d="m138.45 11.098-1.069 1.069a1.07 1.07 0 1 0 1.514 1.514l1.069-1.069 1.069 1.069a1.07 1.07 0 1 0 1.513-1.514l-1.069-1.069 1.069-1.069a1.07 1.07 0 1 0-1.513-1.514l-1.069 1.069-1.069-1.069a1.07 1.07 0 1 0-1.514 1.514Z"
            data-name="Path 100882"
          />
          <path
            fill="#fff"
            d="M118.871 162.331a3.126 3.126 0 1 1-3.126 3.126 3.13 3.13 0 0 1 3.126-3.126m0 4.112a.986.986 0 1 0-.986-.986.987.987 0 0 0 .986.986"
            data-name="Path 100883"
          />
          <path
            fill="#fff"
            d="M177.793 62.71a3.126 3.126 0 1 1-3.126 3.126 3.13 3.13 0 0 1 3.126-3.126m0 4.112a.986.986 0 1 0-.986-.986.987.987 0 0 0 .986.986"
            data-name="Path 100884"
          />
          <path
            fill="#fff"
            d="M46.915 12.534a3.126 3.126 0 1 1-3.126 3.126 3.13 3.13 0 0 1 3.126-3.126m0 4.112a.986.986 0 1 0-.986-.986.987.987 0 0 0 .986.986"
            data-name="Path 100885"
          />
          <path
            fill="#fff"
            d="M10.494 110.147a3.126 3.126 0 1 1-3.126 3.126 3.13 3.13 0 0 1 3.126-3.126m0 4.112a.986.986 0 1 0-.986-.986.987.987 0 0 0 .986.986"
            data-name="Path 100886"
          />
          <path
            fill="#e6e6e6"
            d="M4.526 71.929A15.454 15.454 0 0 0 24.04 73.85l-11 11a15.454 15.454 0 0 0 19.514 23.777l-5.774 5.776a15.454 15.454 0 0 0 19.514 23.777l-1.41 1.411a15.455 15.455 0 1 0 21.856 21.856l14.644-14.644a15.454 15.454 0 0 0 23.777 19.514l22.252-22.251a15.454 15.454 0 0 0 23.777 19.514l34.641-34.641a15.454 15.454 0 0 0-19.514-23.777l7.251-7.251a15.454 15.454 0 0 0-19.514-23.777L168.7 59.486a15.454 15.454 0 0 0-19.514-23.777l9.326-9.326a15.455 15.455 0 0 0-21.856-21.857l-20.774 20.777A15.454 15.454 0 0 0 92.1 5.786l-29.16 29.16a15.454 15.454 0 0 0-23.772-19.515L4.526 50.073a15.454 15.454 0 0 0 0 21.856"
            data-name="Path 100887"
            opacity={0.3}
          />
          <path
            fill="#5078e1"
            d="m189.903 137.801-1.069 1.069a1.07 1.07 0 0 0 1.513 1.513l1.069-1.069 1.069 1.069a1.07 1.07 0 0 0 1.514-1.513l-1.069-1.069 1.069-1.069a1.07 1.07 0 0 0-1.514-1.513l-1.069 1.069-1.069-1.069a1.07 1.07 0 0 0-1.513 1.513Z"
            data-name="Path 100888"
          />
          <path
            fill="#5078e1"
            d="m37.103 160.84-1.069 1.069a1.07 1.07 0 0 0 1.514 1.513l1.069-1.069 1.069 1.069a1.07 1.07 0 0 0 1.513-1.513l-1.069-1.069 1.069-1.069a1.07 1.07 0 1 0-1.513-1.513l-1.066 1.068-1.069-1.069a1.07 1.07 0 1 0-1.514 1.513Z"
            data-name="Path 100889"
          />
          <path
            fill="#5078e1"
            d="m9.743 66.054-1.069 1.069a1.07 1.07 0 1 0 1.514 1.514l1.069-1.069 1.069 1.069a1.07 1.07 0 0 0 1.514-1.514l-1.069-1.069 1.069-1.069a1.07 1.07 0 1 0-1.514-1.513l-1.069 1.069-1.069-1.069a1.07 1.07 0 1 0-1.514 1.513Z"
            data-name="Path 100890"
          />
          <path
            fill="#5078e1"
            d="m138.45 11.098-1.069 1.069a1.07 1.07 0 1 0 1.514 1.514l1.069-1.069 1.069 1.069a1.07 1.07 0 1 0 1.513-1.514l-1.069-1.069 1.069-1.069a1.07 1.07 0 1 0-1.513-1.514l-1.069 1.069-1.069-1.069a1.07 1.07 0 1 0-1.514 1.514Z"
            data-name="Path 100891"
          />
          <path
            fill="#5078e1"
            d="M118.871 162.331a3.126 3.126 0 1 1-3.126 3.126 3.13 3.13 0 0 1 3.126-3.126m0 4.112a.986.986 0 1 0-.986-.986.987.987 0 0 0 .986.986"
            data-name="Path 100892"
          />
          <path
            fill="#5078e1"
            d="M177.793 62.71a3.126 3.126 0 1 1-3.126 3.126 3.13 3.13 0 0 1 3.126-3.126m0 4.112a.986.986 0 1 0-.986-.986.987.987 0 0 0 .986.986"
            data-name="Path 100893"
          />
          <path
            fill="#5078e1"
            d="M46.915 12.534a3.126 3.126 0 1 1-3.126 3.126 3.13 3.13 0 0 1 3.126-3.126m0 4.112a.986.986 0 1 0-.986-.986.987.987 0 0 0 .986.986"
            data-name="Path 100894"
          />
          <path
            fill="#5078e1"
            d="M10.494 110.147a3.126 3.126 0 1 1-3.126 3.126 3.13 3.13 0 0 1 3.126-3.126m0 4.112a.986.986 0 1 0-.986-.986.987.987 0 0 0 .986.986"
            data-name="Path 100895"
          />
          <path
            fill="#fff"
            d="M48.411 122.127a6.614 6.614 0 0 1-6.606-6.606V65.956h62.348a8.258 8.258 0 0 0 5.536-2.125l15.141-13.633a5.762 5.762 0 0 1 3.862-1.482h13.265a6.613 6.613 0 0 1 6.606 6.606v60.2a6.613 6.613 0 0 1-6.606 6.606Z"
            data-name="Path 100896"
          />
          <path
            fill="#5078e1"
            d="M41.801 65.936V55.801a7.093 7.093 0 0 1 7.085-7.085h22.058a11 11 0 0 1 8.5 3.988l12.949 13.232Z"
            data-name="Path 100897"
          />
          <path
            fill="#333"
            d="M148.077 50.698a7.67 7.67 0 0 0-6.126-3.053h-13.265a6.832 6.832 0 0 0-4.579 1.758l-9.053 8.151-6.088 5.481a7.185 7.185 0 0 1-4.818 1.849h-63.42v50.637c0 .093 0 .187.005.279a7.648 7.648 0 0 0 2.355 5.255 7.833 7.833 0 0 0 .693.592 7.638 7.638 0 0 0 4.625 1.553h93.545a7.675 7.675 0 0 0 7.673-7.4c0-.092.005-.186.005-.279v-60.2a7.635 7.635 0 0 0-1.553-4.624m-102.76 69.411a5.531 5.531 0 0 1-2.444-4.588V67.028h61.275a9.33 9.33 0 0 0 6.253-2.4l6.088-5.482 9.053-8.151a4.691 4.691 0 0 1 3.144-1.207h13.265a5.538 5.538 0 0 1 5.534 5.533v60.2a5.54 5.54 0 0 1-5.534 5.534H48.407a5.5 5.5 0 0 1-3.09-.945"
            data-name="Path 100898"
          />
          <path
            fill="#333"
            d="m93.907 65.956-1.049-1.072-1.487-1.52L80.24 51.985l-.015-.018a12.073 12.073 0 0 0-9.285-4.322H48.885a8.167 8.167 0 0 0-8.157 8.157v11.207H94.94ZM78.64 53.422l.111.114L89.84 64.864H42.873v-9.063a6.019 6.019 0 0 1 6.013-6.013H70.94a9.936 9.936 0 0 1 7.7 3.633"
            data-name="Path 100899"
          />
          <path
            fill="#333"
            d="M169.587 122.126a1.072 1.072 0 0 1-1.072 1.072H21.745a1.073 1.073 0 1 1 0-2.145h146.77a1.072 1.072 0 0 1 1.072 1.072"
            data-name="Path 100900"
          />
          <path
            fill="#333"
            d="M17.321 123.199h-4.883a1.073 1.073 0 1 1 0-2.145h4.883a1.073 1.073 0 0 1 0 2.145"
            data-name="Path 100901"
          />
          <path
            fill="#333"
            d="M41.37 117.943h-4.883a1.073 1.073 0 0 1 0-2.145h4.883a1.073 1.073 0 0 1 0 2.145"
            data-name="Path 100902"
          />
          <path
            fill="#333"
            d="M32.062 117.943h-4.884a1.073 1.073 0 0 1 0-2.145h4.884a1.073 1.073 0 0 1 0 2.145"
            data-name="Path 100903"
          />
          <path
            fill="#333"
            d="M153.773 117.943h-4.884a1.073 1.073 0 0 1 0-2.145h4.884a1.073 1.073 0 0 1 0 2.145"
            data-name="Path 100904"
          />
          <path
            fill="#333"
            d="M163.081 117.943h-4.884a1.073 1.073 0 0 1 0-2.145h4.884a1.073 1.073 0 0 1 0 2.145"
            data-name="Path 100905"
          />
          <path
            fill="#333"
            d="M177.822 123.199h-4.884a1.073 1.073 0 0 1 0-2.145h4.884a1.073 1.073 0 0 1 0 2.145"
            data-name="Path 100906"
          />
        </g>
      </g>
    </g>
  </svg>
)
export default NoUnitsAsset


